
import { useEffect, useState, } from "react";
import api from "../../../services/api";
import { InputBase } from "@mui/material";
import HeaderSession from "../../../utils/headerSession";
import ListaExpediente from "../listaExpediente";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


export default function ExpedienteDG() {
    const user = useSelector(state => state.account.user);
    const [expedientes, setExpedientes] = useState('')
    // const [configLista, setConfigLista] = useState('')
    const [page, setPage] = useState('')
    const [filter, setFilter] = useState('')
    const [status, setStatus] = useState('Director Geral')
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (user?.funcao === 'Director Geral' || user?.funcao === 'CNP') {
        } else {
          dispatch({
            type: 'alert',
            payload: { alert: 'Acesso negado' },
          });
          navigate('/admin/expediente')
        }

        api.get(`/expedientes?status=${status}&page=${page}`)
            .then(response => {
                // console.log(response)
                setExpedientes(response.data.expedientes);
                setFilter(response.data.expedientes);
                // setConfigLista(response.data);
            }).catch(err => '')
    }, [page, status])

    const filtraexpedientes = (valor) => {
        setExpedientes(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
    }

    return (
        <div>
            <HeaderSession title={'EXPEDIENTES ENCAMINHADO PARA DIRECTOR GERAL'} />

            <div style={{ display: 'flex', marginBottom: 20 }}>

                <InputBase
                    style={{ width: '70%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                    sx={{ ml: 1, flex: 1 }}
                    autoFocus
                    placeholder="Filtro"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { filtraexpedientes(e.target.value) }}
                />

                {/* <TextField
                        style={{ width: 200 }}
                        type="text"
                        label="Estado"
                        select
                        size="small"
                        variant="outlined"
                        onChange={(e) => { setStatus(e.target.value) }}
                        defaultValue={'Análise'}
                    >
                        <MenuItem key='Análise' value='Análise'> Análise </MenuItem>
                        <MenuItem key='Concluído' value='Concluído'> Já respondidos </MenuItem>

                    </TextField> */}
            </div>

            <ListaExpediente
                expedientes={expedientes}
                setPage={setPage}
            />

        </div>
    )
}
